module.exports = __webpack_public_path__ + "img/bg.a378ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/UpgradeModal/images/bg.png
// module id = e/8D
// module chunks = 47